import { useRef } from 'react';
import { toast } from 'sonner';

export function useCooldownAction(cooldownPeriod = 10000) {
  const lastCalledRef = useRef(0);

  const runWithCooldown = async (asyncFn, warnMessage = 'You have recently used this function. Try again after 10 seconds.') => {
    const now = Date.now();

    if (now - lastCalledRef.current < cooldownPeriod) {
      // Custom warning toast: Use generic toast() with warning styling
      toast.warning(warnMessage, {
        icon: '⚠️', // Or use a custom theme/component: icon: '🚨'
        style: {
          background: '#fef3c7', // Soft yellow for warning
          color: '#92400e',      // Dark text for readability
          border: '1px solid #f59e0b',
        },
        duration: 4000, // Matches default error duration
      });
      return;
    }

    lastCalledRef.current = now;

    try {
      await asyncFn();
    } catch (err) {
      throw err;
    }
  };

  return runWithCooldown;
};